import Carousel from 'react-material-ui-carousel'
import { Container as ContainerBase, styled } from '@mui/material'
import { NavigateBefore as NavigateBeforeBase, NavigateNext as NavigateNextBase } from '@mui/icons-material'

export const CarouselBase = styled(Carousel)`
  &.CarouselItem > div:nth-child(2) {
    right: 100px;
    ${props => props.theme.breakpoints.down('md')} {
      right: 0;
    }
  }
  &.CarouselItem > div:nth-child(3) {
    left: 100px;
    ${props => props.theme.breakpoints.down('md')} {
      left: 0;
    }
  }
`

export const Root = styled('div')`
  width: 100%;
`

export const Content = styled(ContainerBase)`
  &.MuiContainer-root {
    width: 100%;
  }
`

export const NavigateNextIcon = styled(NavigateNextBase)``

export const NavigateBeforeIcon = styled(NavigateBeforeBase)
